import React, { useState } from "react"
import VizSensor from "react-visibility-sensor"
import { getSrc } from "gatsby-plugin-image"

import { Cta } from "@components/common/cta/Cta"
import { Carousel } from "@components/common/carousel/Carousel"
import { Video } from "@components/common/video/Video"

import { Props } from "./Billboard.interface"
import * as s from "./Billboard.module.scss"

export const Billboard = ({ data }: Props) => {
  const {
    title,
    subTitle,
    blurb,
    links,
    direction,
    images,
    image,
    videoUrl,
    hideVideoPlayButton,
    color,
    blockType,
    videoFile,
  } = data

  const [visibilityClass, setVisibilityClass] = useState(false)

  const onChangeVisibility = isActive => {
    if (isActive) {
      setVisibilityClass(true)
    }
  }

  const hasMedia =
    blockType === "carousel" || blockType === "video" || blockType === "image"
  const mediaClass = hasMedia
    ? s.Billboard__withImage
    : s.Billboard__withoutImage

  const rowDirection =
    direction === "RTL"
      ? s.Billboard__withImage___RTL
      : direction === "LTR"
        ? s.Billboard__withImage___LTR
        : null

  const _renderBillboardMedia = () => {
    if (blockType === "carousel") {
      return (
        <Carousel
          styleType={"BRAND"}
          data={
            images && {
              slides: images.map(image => {
                return {
                  image: image.image.localFile
                    ? getSrc(image.image.localFile)
                    : image.image.sourceUrl,
                }
              }),
            }
          }
        />
      )
    } else if (blockType === "video") {
      const videoSrc =
        videoFile && videoFile.mediaItemUrl ? videoFile.mediaItemUrl : videoUrl

      return (
        <Video
          url={videoSrc}
          className={s.MediaBlock}
          hidePlayButton={hideVideoPlayButton}
          cover={true}
          flexibleHeight={false}
        />
      )
    } else if (blockType === "image") {
      return (
        <div
          role="image"
          aria-label={image && image.altText ? image.altText : title}
          className={s.BillboardImage}
          style={{
            backgroundImage: `url(${image && image.localFile ? getSrc(image.localFile) : image.sourceUrl})`,
          }}
        ></div>
      )
    } else if (blockType === "text") {
      return <></>
    }
  }

  const colorClass = color => {
    switch (color) {
      case "black":
        return s.Billboard__black
        break
      case "red":
        return s.Billboard__red
        break
      case "yellow":
        return s.Billboard__yellow
        break
    }
  }

  return (
    <VizSensor partialVisibility onChange={e => onChangeVisibility(e)}>
      <div
        className={`
      ${s.Billboard} 
      ${mediaClass} 
      ${rowDirection} 
      ${colorClass(color)}
      ${visibilityClass && s.Billboard___isVisible}
      `}
      >
        {hasMedia && (
          <div
            className={`${s.BillboardSplitSection} ${s.BillboardSplitSection__media}`}
          >
            {_renderBillboardMedia()}
          </div>
        )}

        <div className={s.BillboardSplitSection}>
          <div className={s.BillboardSplitSection__textInner}>
            {subTitle && <h3 className={s.Billboard__subTitle}>{subTitle}</h3>}
            {title && (
              <h2
                className={s.Billboard__title}
                dangerouslySetInnerHTML={{
                  __html: title.replace(
                    "OoofT",
                    'Ooof<span style="color: red;">T</span>',
                  ),
                }}
              />
            )}
            {blurb && <p className={s.Billboard__blurb}>{`${blurb}`}</p>}

            {links && (
              <div className={s.Links}>
                {links.map((link, idx) => {
                  if (!link.link) return null
                  if (!link.link.title || !link.link.url) return null

                  return (
                    <Cta
                      key={idx}
                      target={link.link.target}
                      className={s.Links__Link}
                      title={link.link.title}
                      link={link.link.url}
                      external={link.link.target === "_blank"}
                    />
                  )
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </VizSensor>
  )
}
